<template>
  <section>
    <p
      v-if="!isDocumentTypesAvailable"
      class="alert-style"
    >
      No document types were found against you to upload; please click on the
      'Accept' button to continue the registration process.
    </p>
    <v-form
      v-if="isDocumentTypesAvailable"
      ref="form"
      v-model="valid"
    >
      <div
        v-for="(item, i) in workerDocumentTypes"
        :key="item.id"
      >
        <p class="title-text-style">
          Document {{ i + 1 }} -
          <font class="value-text-style">
            {{ item.name }}
          </font>
        </p>
        <v-file-input
          :id="`assetsFieldHandle${i}`"
          ref="file"
          v-model="documentUploads[item.id]"
          :rules="
            (item.mandatory == true
              ? [(v) => !!v || 'This field is required']
              : []
            ).concat(sizeRules, fileTypeRules)
          "
          show-size
          color="#000000"
          prepend-icon=""
          style="margin-bottom: 10px"
          background-color="transparent"
          dense
          light
          class="ma-0 pa-0 upload-box"
          :prepend-inner-icon="removeIcon"
          placeholder="Upload File"
          elevation="0"
          solo
          flat
          accept=".jpg,.jpeg,.png,.pdf"
        />
        <br>
        <v-dialog
          :ref="'dialog' + i"
          v-model="calendarDialog[item.id]"
          :return-value.sync="documentExpiry[item.id]"
          width="290px"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="documentExpiry[item.id]"
              placeholder="Expiry Date"
              outlined
              :rules="
                item.mandatory == true
                  ? [(v) => !!v || 'This field is required']
                  : []
              "
              filled
              readonly
              hint="Please select the document expiry date."
              color="#000000"
              dense
              light
              prepend-inner-icon="mdi-calendar-month-outline"
              background-color="transparent"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-if="calendarDialog[item.id]"
            v-model="documentExpiry[item.id]"
            full-width
            color="#37474F"
            light
            :min="minExpiryDate"
            @input="$refs['dialog' + i][0].save(documentExpiry[item.id])"
          >
            <v-spacer />
            <v-btn
              text
              color="#37474F"
              @click="calendarDialog[item.id] = false"
            >
              Cancel
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </div>
      <p class="small-style">
        I hereby declare that the document uploaded here is correct and valid. I
        will present the same when required.
        <v-checkbox
          v-model="agree"
          light
          dense
          color="#FF3700"
          label="I Agree*"
        />
      </p>
    </v-form>
    <v-btn
      color="#64CA7F"
      class="mt-5 btn-style"
      elevation="0"
      @click="acceptDeclaration()"
    >
      {{ buttonName }}
    </v-btn>
    <v-btn
      light
      color="#E6E6E6"
      class="mt-3 btn-style"
      elevation="0"
      @click="cancel()"
    >
      Cancel
    </v-btn>
    <centre-spinner :loading="loading" />
  </section>
</template>
<script>
import spinner from 'src/views/components/SpinnerCentre';
import Constants from 'src/constants';
import moment from 'moment';

export default {
  name: 'UploadDocuments',
  components: {
    'centre-spinner': spinner,
  },
  data () {
    return {
      agree: false,
      selectedOrganization: null,
      documentUploads: {},
      documentExpiry: {},
      calendarDialog: {},
      loading: false,
      minExpiryDate: moment().format('YYYY-MM-DD'),
      valid: false,
      sizeRules: [
        (value) =>
          !value ||
          value.size < 10000000 ||
          'File size should be less than 10 MB!',
      ],
      fileTypeRules: [
        (v) =>
          !v ||
          ['application/pdf', 'image/jpeg', 'image/png'].includes(v.type) ||
          'Only PDF, JPG, PNG, and JPEG files are allowed.',
      ],
    };
  },
  computed: {
    userDetails () {
      return this.$store.getters.getUser;
    },
    workerDocumentTypes () {
      return this.$store.getters['register/getDocumentTypes'];
    },
    isDocumentTypesAvailable () {
      if (this.workerDocumentTypes.length > 0) {
        return true;
      }
      return false;
    },
    removeIcon (id) {
      if (Object.keys(this.documentUploads).length === 0) {
        return 'mdi-cloud-upload';
      } else {
        return '';
      }
    },
    // selectedOrganization () {
    //   return this.$store.getters.getSelectedOrganization;
    // },
    organizationsPendingRequests () {
      return this.$store.getters[
        'organization/getOrganizationsPendingRequests'
      ];
    },
    isAnyReqAvailable () {
      if (this.organizationsPendingRequests.length === 0) {
        return false;
      }
      return true;
    },
    buttonName () {
      if (
        this.workerDocumentTypes.length > 0 &&
        Object.keys(this.documentUploads).length > 0
      ) {
        return 'Upload';
      }
      return 'Accept';
    },
  },
  async mounted () {
    await this.getOrganizationsPendingRequests();
    await this.fetchWorkerDocumentTypes();
  },
  methods: {
    async getOrganizationsPendingRequests () {
      this.loading = true;
      await this.$store
        .dispatch('organization/fetchOrganizationsPendingRequests', {
          params: {
            requestStatus: 'pending',
          },
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async fetchWorkerDocumentTypes () {
      if (!this.isAnyReqAvailable) {
        this.$router.push({ name: 'Organizations' });
      }
      this.loading = true;

      this.$store.dispatch('register/clearStoredDocumentTypes');
      const organizationExtId = this.$route.params.organizationexternalid;
      const currentOrganization = this.organizationsPendingRequests.filter(
        (item) => item.organization.external_id === organizationExtId,
      );
      this.selectedOrganization = currentOrganization[0];
      const orgWorkerCategoryId = currentOrganization[0].worker_category.id;
      await this.$store
        .dispatch('register/fetchWorkerDocumentTypes', {
          categoryId: orgWorkerCategoryId,
        })
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async acceptDeclaration () {
      if (this.isDocumentTypesAvailable === false) {
        this.acceptOrganizationRequest();
        return;
      }
      if (this.$refs.form.validate() === false) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'Please upload all mandatory documents',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        return;
      }
      if (this.agree === false) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'Please agree above declaration before proceeding.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        return;
      }
      this.loading = true;
      const organizationExtId = this.$route.params.organizationexternalid;
      await this.$store
        .dispatch('register/acceptDeclaration', {
          declarationDetails: {
            declaration_type: 'documentUpload',
            is_agree: this.agree,
            time: moment.utc().format(),
          },
          externalId: organizationExtId,
          appUserId: this.userDetails.app_user.external_id,
        })
        .then((response) => {
          this.loading = false;
          this.uploadDocument();
        })
        .catch((errors) => {
          this.loading = false;
        });
    },
    async uploadDocument () {
      this.loading = true;
      const organizationExtId = this.$route.params.organizationexternalid;
      const documentDetails = Object.keys(this.documentUploads).map((id) => {
        return {
          document_file: this.documentUploads[id],
          expiry: this.documentExpiry[id],
          document_type_id: id,
        };
      });
      for (var i = 0; i < documentDetails.length; i++) {
        const formData = new FormData();
        formData.append('document_file', documentDetails[i].document_file);
        formData.append('expiry', documentDetails[i].expiry);
        formData.append(
          'document_type_id',
          documentDetails[i].document_type_id,
        );
        await this.$store
          .dispatch('register/uploadDocumentFiles', {
            documentDetails: formData,
            externalId: organizationExtId,
            appUserId: this.userDetails.app_user.external_id,
          })
          .catch(() => {
            this.loading = false;
          });
      }
      this.acceptOrganizationRequest();
    },
    async acceptOrganizationRequest () {
      const organizationExtId = this.$route.params.organizationexternalid;
      await this.$store
        .dispatch('organization/acceptOrganizationRequest', {
          organizationExtId: {
            organization_id: organizationExtId,
          },
        })
        .then((response) => {
          this.loading = false;
          this.$store.dispatch('alert/onAlert', {
            message: 'Request accepted successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
            this.$store.commit(
              'setSeletedOrganization',
              this.selectedOrganization,
            );
          location.reload();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    cancel () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'Organizations' });
      }, 1000);
    },
  },
};
</script>
<style scoped>
.alert-style {
  font-size: 18px;
  color: #c62828;
  font-weight: bold;
  margin-top: 50px;
  margin-bottom: 50px;
}

.small-style {
  font-size: 14px;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  color: black;
}
::v-deep .v-input--selection-controls__input .v-icon {
  color: rgb(8, 8, 8) !important;
}
</style>
